import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Link } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqList = [
  {
    question: "What is CAT protocol?",
    answer: (
      <Typography>
        It's a novel UTXO-based token protocol on Bitcoin, called Covenant Attested Token (CAT) Protocol.{' '}
        <Link href="https://catprotocol.org/" target="_blank" rel="noopener noreferrer">Learn more</Link>
      </Typography>
    )
  },
  {
    question: "Why do I need to upgrade?",
    answer: (
      <Typography>
        Upgrading ensures that you have access to the latest features and improvements in the CAT protocol. v2 introduces several improvements over v1, including enhanced security, better performance, and new features that improve the overall user experience.
      </Typography>
    )
  },
  {
    question: "Which CAT20/CAT721 tokens can be upgraded?",
    answer: (
      <Typography>
        All the valid CAT20/CAT721 tokens that are either:
        <br />
        <br />
        1. Minted by using the official open-minters whose md5 is included in this list -&gt; [
        '21cbd2e538f2b6cc40ee180e174f1e25',
        'a6c2e92d74a23c07bb6220b676c6cb9b',
        '86fe8c275b45c796bb9500b815d48820',
        ]
        <br />
        <br />
        2. Already have been minted out before the upgrade.
      </Typography>
    )
  },
  {
    question: "Does upgrading require a fee?",
    answer: (
      <Typography>
        During the upgrade process, a small on-chain fee will be provided by your wallet for transferring v1 tokens. However, there are no additional fees for upgrading. The service provider will cover all other on-chain fees.
      </Typography>
    )
  },
  {
    question: "How to upgrade my CAT20/CAT721 token?",
    answer: (
      <Typography>
        Please connect your wallet to the page and click the “upgrade” button to transform the upgradable tokens that belong to your wallet. However, please note that each upgrade transaction has a limit on the number of  token UTXOs that can be upgraded. If you have a large number of token UTXOs to upgrade, you may need to perform multiple transactions.
      </Typography>
    )
  },
  {
    question: "How long does the upgrade process take?",
    answer: (
      <Typography>
        The duration of the upgrade process can vary depending on network conditions and the request load. Generally, it should only take a few minutes. And you can find the upgrade transaction status in the "History" section. However, please note that the history are only stored locally in your browser and will be cleared if you clear your browser data.
      </Typography>
    )
  },
  {
    question: "Where can I find the upgraded v2 tokens?",
    answer: (
      <Typography>
        Once the upgrade is complete, the upgraded v2 tokens will be available in your wallet. You can view them by connecting your wallet to the appropriate interface.
      </Typography>
    )
  },
  {
    question: "What if I encounter problems?",
    answer: (
      <Typography>
        Please join the official community or contact customer service at the bottom of the page.{' '}
        <Link href="https://t.me/opcatbtc" target="_blank" rel="noopener noreferrer">Telegram</Link>
      </Typography>
    )
  }
];

export default function FAQCollapse() {
  return (
    <div>
      {faqList.map((item, idx) => (
        <Accordion key={idx}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{item.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {item.answer}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
